// snow.js - Efecto de nieve optimizado para Shopify
(function() {
  // Respetar preferencias de accesibilidad
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  canvas.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:9999';
  document.body.appendChild(canvas);
  
  let width, height;
  let snowflakes = [];
  let lastTime = 0;
  
  // Optimización: menos copos en móvil
  const isMobile = window.innerWidth < 768;
  const maxFlakes = isMobile ? 40 : 80;
  
  function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }
  
  function createSnowflake() {
    return {
      x: Math.random() * width,
      y: Math.random() * -50,
      r: Math.random() * 3 + 1,
      speed: Math.random() * 1 + 0.5,
      wind: Math.random() * 0.5 - 0.25
    };
  }
  
  function animate(currentTime) {
    // Delta time: normalizado a 60fps (16.67ms por frame)
    const deltaTime = lastTime ? (currentTime - lastTime) / 16.67 : 1;
    lastTime = currentTime;
    
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
    
    if (snowflakes.length < maxFlakes) {
      snowflakes.push(createSnowflake());
    }
    
    snowflakes.forEach((flake, i) => {
      // Movimiento ajustado por delta time
      flake.y += flake.speed * deltaTime;
      flake.x += flake.wind * deltaTime;
      
      ctx.beginPath();
      ctx.arc(flake.x, flake.y, flake.r, 0, Math.PI * 2);
      ctx.fill();
      
      if (flake.y > height) {
        snowflakes[i] = createSnowflake();
      }
    });
    
    requestAnimationFrame(animate);
  }
  
  resize();
  window.addEventListener('resize', resize);
  requestAnimationFrame(animate);
})();